import { useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { openScanToSearchModal } from '../../../store/orders/orders.actions';
import { useBarcodeScanningFeatureGate } from '../../../feature-gates/use-barcode-scanning-feature-gate';
import { messages } from './messages';

export const useScanToSearch = () => {
  const dispatch = useDispatch();

  const actionHandler = useCallback(() => {
    dispatch(openScanToSearchModal());
  }, [dispatch]);

  const { isFeatureEnabled, disabledMessage } = useBarcodeScanningFeatureGate(); // @design-input-pending

  return useMemo(() => {
    return {
      actionHandler,
      nameDescriptor: messages.orderGridOtherActionsBarcodeSearch,
      isDisabled: !isFeatureEnabled,
      disabledReason: disabledMessage,
    };
  }, [actionHandler, disabledMessage, isFeatureEnabled]);
};
